import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Alert from './img/alert@2x.png';
import { Overlay } from './../UIComponents';
import './Modal.scss';

export default function RecordConfirmSetupModal(props) {
  return (
    <div className={classnames('modal', { open: props.visibility })} >
      <Overlay>
        <div className="call-forwarding-modal">
          <h4>Record New Greetings</h4>
          <img src={Alert} alt="Warning" width="41" />
          <p>
            Any custom greeting that currently exists will be lost.
            Are you sure you like to record new greetings?
          </p>
          <div className="call-forwarding-modal__actions">
            <button
              className="btn btn--secondary btn--lg action"
              onClick={props.onCancel}
            >
              Cancel
            </button>
            <button
              className="btn btn--primary btn--lg action"
              onClick={props.onConfirm}
            >
              Yes
            </button>
          </div>
        </div>
      </Overlay>
    </div>
  );
}

RecordConfirmSetupModal.defaultProps = {
  visibility: false,
  onConfirm: () => {},
  onCancel: () => {},
};

RecordConfirmSetupModal.propTypes = {
  visibility: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
};
